/* eslint-disable no-unused-vars */
import axios from '@/api/api.js'
import {
  GET_ALL_USERS,
  GET_EDIT_REASONS,
  GET_ALL_PRODUCT_REGISTRATIONS,
  UPDATE_PRODUCT_REGISTRATION,
  IS_PRODUCT_REGISTERED
} from '../endpoints/security-controller-endpoints'
import { queryOptions } from '@tanstack/react-query'

export const getAllUsers = async () => {
  const response = await axios.get(GET_ALL_USERS)
  return response.data
}

export const getAllProductRegistrations = async () => {
  const response = await axios.get(GET_ALL_PRODUCT_REGISTRATIONS)
  return response.data
}

export const updateProductRegistration = async data => {
  const response = await axios.post(UPDATE_PRODUCT_REGISTRATION, data)
  return response.data
}

export const getEditReasons = async (tableName, pkValue1) => {
  const response = await axios.get(GET_EDIT_REASONS, {
    params: {
      tableName,
      pkValue1
    }
  })
  return response.data
}
